import { render } from "./Disabled.vue?vue&type=template&id=31291ba8&scoped=true"
const script = {}

import "./Disabled.vue?vue&type=style&index=0&id=31291ba8&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31291ba8"]])

export default __exports__